const StatCard = ({data}) => {
    return (
        <div
            className={'h-max subtle-light-shadow bg-black text-white lg:w-80 md:w-72 sm:w-64 w-full px-4 py-6 shadow-amber-50 drop-shadow-lg border-b-yellow border-b-8 rounded-md'}>
            <h1 className={'text-yellow font-medium mb-2'}>
                <span className={'text-2xl md:text-3xl font-semibold'}>{data.highlight} </span>
                <span className={'text-md md:text-lg'}>{data.title}</span>
            </h1>
            <span className={'text-[10px] md:text-xs'}>{data.description}</span>
        </div>
    );
}

export default StatCard;
